import React from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthImaage from "../../assets/images/authbanner.png";
import { useForm, SubmitHandler } from "react-hook-form";
import { AuthModal, ButtonLarge, emailValidator, FormHookInput, Loader } from "@thdinc/hpf-shared";
import { POST } from "@/services/api";
import { API_ROUTES } from "@/services/environment";
import Alert from "@/components/alert/Alert";
import useLoading from "@/hooks/useLoading";
import useError from "@/hooks/useError ";

const ForgetPassword = () => {
  const { forgotPassword } = API_ROUTES;
  const navigate = useNavigate();
  const { isLoading, startLoading, stopLoading } = useLoading();
  const [error, setCustomError] = useError()

  type Inputs = {
    email: string;
  };
  const {
    register,
    handleSubmit,

    formState: { errors },
  } = useForm<Inputs>();

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    try {

      startLoading();
      const res = await POST(forgotPassword, data);
      if (res?.data?.success === true) {
        Alert({ message: "Email sent" });
        //if success app will navigate to check email page
        navigate("/checkemail", { state: { email: data.email } });
      } else {
        Alert({ message: "Something went wrong", type: "error" });
        setCustomError('forget', res?.data?.message)
      }
    } catch (error) {
      console.log(error);
      setCustomError('forget', 'Something went wrong')
      // Alert({ message: "Something went wrong", type: "error" });
    } finally {
      stopLoading();
    }
  };
  return (
    <div className="container mx-auto h-screen relative">
      <div className="flex flex-col justify-center   min-h-full ">
        <div className="flex justify-center">
          <img
            className="w-[500px] hidden lg:block rounded-3xl"
            src={AuthImaage}
            alt=""
          />
          <div className="flex flex-col justify-center lg:-ml-11">
            <AuthModal>
              <div className="text-center">
                <p className="text-2xl font-bold ">Reset Password</p>
                <p className=" mt-6">
                  Enter the email address associated with the account.
                </p>
              </div>
              <form
                className="mt-8 space-y-6"
                onSubmit={handleSubmit(onSubmit)}
              >
                <div>
                  <div className=" font-semibold my-2">Email</div>
                  <FormHookInput
                    type="email"
                    placeholder="Email"
                    register={register("email", {
                      required: "Email is required!",
                      pattern: emailValidator,
                    })}
                    error={errors.email}
                  />
                </div>
                {error?.name === 'forget' && <p className="text-primary-red text-center mt-">{error.message}</p>}

                <div className="mt-8">
                  <ButtonLarge classes="min-w-full" disabled={isLoading} type="submit">
                    {isLoading ? <Loader /> : "Send Password Reset"}
                  </ButtonLarge>
                </div>

                <div className="text-center mt-4">
                  <Link to="/login" className="text-primary-red  ">
                    Cancel
                  </Link>
                </div>
              </form>
            </AuthModal>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgetPassword;
